import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './ItemWrapper.module.scss';

type ItemWrapperProps = {
  children: ReactNode;
  hasSubItems?: boolean;
  onClick?: () => void;
  to?: string;
  closeMobileMenu?: () => void;
};

const ItemWrapper: FC<ItemWrapperProps> = ({
  children,
  hasSubItems,
  onClick,
  to,
  closeMobileMenu,
}) => {
  if (hasSubItems) {
    return (
      <button onClick={onClick} className={styles.itemWrapper} type="button">
        {children}
      </button>
    );
  }

  return (
    <Link
      onClick={closeMobileMenu}
      className={styles.itemWrapper}
      to={to ?? ''}
    >
      {children}
    </Link>
  );
};

export default ItemWrapper;
